import { render, staticRenderFns } from "./BomProductTree.vue?vue&type=template&id=3553068a&"
import script from "./BomProductTree.vue?vue&type=script&lang=js&"
export * from "./BomProductTree.vue?vue&type=script&lang=js&"
import style0 from "./BomProductTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports